/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { TranslocoModule } from '@jsverse/transloco';
import { AvatarModule } from 'src/app/avatar/avatar.module';
import { ConnectedFamilyMembersComponent } from './connected-family-members/connected-family-members.component';
import { FamilyMemberActivityFeedComponent } from './family-member-activity-feed/family-member-activity-feed.component';
import { FamilyMemberBaseContainerComponent } from
  './family-member-base-container/family-member-base-container.component';
import { FamilyMemberContainerComponent } from './family-member-container/family-member-container.component';
import { FamilyMemberDividerComponent } from './family-member-divider/family-member-divider.component';
import { AnchorScrollProvider, StateProvider, LocationProvider } from '../app/angularjs.providers';

import { UtilsModule } from '../utils/utils.module';

/**
 * Feature Module for Family Accounts and Family Members
 */
@NgModule({
  declarations: [
    ConnectedFamilyMembersComponent,
    FamilyMemberActivityFeedComponent,
    FamilyMemberBaseContainerComponent,
    FamilyMemberContainerComponent,
    FamilyMemberDividerComponent,
  ],
  providers: [
    AnchorScrollProvider,
    LocationProvider,
    StateProvider,
  ],
  imports: [
    AvatarModule,
    CommonModule,
    InfiniteScrollModule,
    TranslocoModule,
    UtilsModule,
  ],
})
export class FamilyMemberModule { }
